import { IconButton, Stack } from "@mui/material";
import { observer } from "mobx-react";
import { CombinatorRuleType } from "models/RuleCombinator";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import HelpIcon from "@mui/icons-material/Help";
import AcxButton from "components/UI/AcxButton";
import OutlineDefinitionsDialog from "components/Conversations/Views/Main/FocusedConversation/components/OutlineDefinitionsDialog";
import { blueButtonWhiteBackgroundStyle } from "utils/Style";
import { FilterLabel } from "../../shared";
import OutlineFilterItem from "./OutlineFilterItem";
import OutlineFilterStore from "./OutlineFilterStore";

interface Props {
    store: OutlineFilterStore;
}

const OutlineFilterInput: React.FunctionComponent<Props> = observer(
    ({ store }) => {
        const [isAddingItem, setIsAddingItem] = useState(false);
        const [isOutlineDefinitionsOpen, setIsOutlineDefinitionsOpen] =
            useState(false);

        const handleAdd = (combinator: CombinatorRuleType) => {
            store.addOutlineFilterItem(combinator);
            setIsAddingItem(false);
        };

        const renderAddBlockButton = (
            <IconButton
                size="small"
                onClick={() => {
                    if (store.outlineFilterItems.length === 0) {
                        store.addOutlineFilterItem(0);
                    } else {
                        setIsAddingItem(true);
                    }
                }}
            >
                <AddIcon
                    sx={{
                        border: "1px solid #E4E4E7",
                        borderRadius: "4px",
                    }}
                />
            </IconButton>
        );

        const renderAddAndOrButtons = (
            <Stack direction="row" gap={1} mt={1}>
                <AcxButton
                    id="outline-filter-input-add-and-button"
                    onClick={() => handleAdd(CombinatorRuleType.And)}
                    style={blueButtonWhiteBackgroundStyle}
                >
                    + AND
                </AcxButton>
                <AcxButton
                    id="outline-filter-input-add-or-button"
                    onClick={() => handleAdd(CombinatorRuleType.Or)}
                    style={blueButtonWhiteBackgroundStyle}
                >
                    + OR
                </AcxButton>
            </Stack>
        );

        return (
            <>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ paddingBottom: 0.5 }}
                >
                    <Stack direction="row" alignItems="center" gap={0.5}>
                        <FilterLabel sx={{ mb: 0 }}>Outline</FilterLabel>
                        <IconButton
                            id="open-outline-definitions-dialog"
                            color="primary"
                            onClick={() => {
                                setIsOutlineDefinitionsOpen(true);
                            }}
                            size="small"
                        >
                            <HelpIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                    {renderAddBlockButton}
                </Stack>
                {store.outlineFilterItems.map((item, index) => (
                    <OutlineFilterItem
                        item={item}
                        index={index}
                        key={index}
                        store={store}
                    />
                ))}
                {isAddingItem && renderAddAndOrButtons}
                <OutlineDefinitionsDialog
                    isOpen={isOutlineDefinitionsOpen}
                    onClose={() => setIsOutlineDefinitionsOpen(false)}
                />
            </>
        );
    },
);

export default OutlineFilterInput;
